export default function HeaderSub() {
  return (
    <section className="bg-slate-50">
      <div className="widthcontainer mx-auto text-center p-6 lg:p-4 ">
        <div className="items-center">Digital Product Management and UX Consultancy</div>
      </div>
    </section>
  );
}
